import SidebarRight, {
  SidebarRightContent,
  SidebarToggler,
} from './SidebarRight';

export { SidebarRightContent, SidebarToggler };

export default SidebarRight;
